import { RavenTooltip } from "@ravenappdev/raven-ui";
import type { TooltipProps } from "@mui/material/Tooltip";

export default function Tooltip(props: TooltipProps) {
  return <RavenTooltip arrow {...props} />;
}
